/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-06 14:28:53
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { useState } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { MobileHorizontalDotsMajor } from '@shopify/polaris-icons';
import { Badge, Popover, Button, ActionList } from '@shopify/polaris';
import UnsubscribeModal from './unsubscribe-modal';
import ConfirmRemoveModal from 'src/components/views/subscription-v3/modal/remove-modal';
import ProcessAddon from 'src/components/views/subscription-v3/addon/process-addon';

import { ANALYTICS_ADDON, ADDONS_INFO } from 'src/constants/subscription';
import { DATE_FORMAT } from 'src/constants/language-setting';
import moment from 'moment';

//--------------------------
// Addon Row
const AddonRow = props => {
  // props
  const {
    i18n,
    addon = {},
    appLanguage,
    trialExpiresAt,
    nextBillingDate,
    storeStatus,
    unsubscribing,
    onOpenFeedback,
    unsubscribeAddonInfo,
    handleUnsubscribe,
    getDetailInvoice,
    getAddons
  } = props;

  // useState
  const [activeUnsubscribeModal, setActiveUnsubscribeModal] = useState(false);
  const [activeModalConfirm, setActiveModalConfirm] = useState(false);
  const [activePopover, setActivePopover] = useState(false);
  const [openModalReview, setOpenModalReview] = useState(false);

  let addonName = _.get(addon, 'addOnName', null);
  const id = _.get(addon, 'id', null);
  const isTrialPeriod = _.get(addon, 'isTrialPeriod', false);
  const trialEndDate = _.get(addon, 'trialEndDate', 0);
  const cancelAt = _.get(addon, 'cancelAt', null);
  // Define analytic value
  let analytic = null;
  if (_.includes(addonName, 'analytics')) {
    analytic = ANALYTICS_ADDON.find(e => e.name === addonName);
    addonName = 'analytics';
  }
  const addonInfo = ADDONS_INFO.find(e => e.addonName === addonName) || {};
  const { title = '', price = 0 } = addonInfo;

  if (_.isEmpty(addonInfo) || !addonInfo) return null;

  const correctPrice = analytic ? analytic.price : price;

  const addonStatus = getAddonStatus(isTrialPeriod, cancelAt, storeStatus);

  // Function
  const handleOpenFeedback = () => {
    if (!unsubscribeAddonInfo?.cancelAt) {
      onOpenFeedback(_.includes(addonName, 'analytics') ? addonName : i18n.translate(title));
    }
  };

  const handleAfterSubscribeAddon = async () => {
    await getAddons();
    await getDetailInvoice();
  };

  // Unsubscribe 1 addon
  const handleConfirmUnsubscribe = async () => {
    //Call api unsubscribe

    await handleUnsubscribe(id, _.get(addon, 'addOnName', null), isTrialPeriod);
    // .catch(e => {});
    setActiveUnsubscribeModal(false);
    setActiveModalConfirm(false);
    handleOpenFeedback();

    if (isTrialPeriod) {
      await handleAfterSubscribeAddon();
    }
  };

  // Render row addon info

  const activator = (
    <Button plain icon={MobileHorizontalDotsMajor} onClick={() => setActivePopover(true)} />
  );

  // process addon
  const handleProcessAddon = status => {
    if (status === 'expireSoon') {
      // open review addon modal
      setOpenModalReview(true);
      setActivePopover(false);
      return;
    }
    // Open modal confirm unsubscribe
    if (isTrialPeriod) {
      setActiveModalConfirm(true);
      setActivePopover(false);
    } else {
      setActiveUnsubscribeModal(true);
      setActivePopover(false);
    }
  };

  let expireDateAddon = nextBillingDate;
  if (['trial', 'expired'].includes(addonStatus.status)) {
    if (trialEndDate) {
      expireDateAddon = trialEndDate * 1000;
    } else expireDateAddon = trialExpiresAt * 1000;
  }

  return (
    <div className="addon-item">
      <div> {i18n.translate(analytic ? analytic.label : title)}</div>
      <div>
        <Badge status={addonStatus.color}>
          <span style={{ color: `${addonStatus.status === 'expired' ? '#8C9196' : ''}` }}>
            {i18n.translate(`AdminHTML.SubscriptionV3.PlanStatus.${addonStatus.label}`)}
          </span>
        </Badge>
      </div>
      <div>
        {addonStatus.status === 'expired'
          ? '--'
          : moment(expireDateAddon).format(DATE_FORMAT[appLanguage].longDate)}
      </div>
      <div>
        {i18n.translate('AdminHTML.SubscriptionV3.Common.pricePerMonth', {
          price: correctPrice
        })}
      </div>
      <div>
        <Popover
          active={activePopover}
          activator={activator}
          onClose={() => setActivePopover(false)}>
          <ActionList
            actionRole="menuitem"
            items={[
              {
                content: i18n.translate(`AdminHTML.Common.Action.${addonStatus.actionLabel}`),
                onAction: () => handleProcessAddon(addonStatus.status)
              }
            ]}
          />
        </Popover>
      </div>
      <UnsubscribeModal
        active={activeUnsubscribeModal}
        unsubscribing={unsubscribing}
        handleCancel={() => setActiveUnsubscribeModal(!activeUnsubscribeModal)}
        handleConfirm={() => handleConfirmUnsubscribe()}
        item={{
          name: i18n.translate(title),
          expiredAt: nextBillingDate
        }}
      />
      {/* Remove addon when addon trial */}
      <ConfirmRemoveModal
        name={i18n.translate(title)}
        unsubscribing={unsubscribing}
        active={activeModalConfirm}
        handleCancel={() => setActiveModalConfirm(!activeModalConfirm)}
        handleUnsubscribe={handleConfirmUnsubscribe}
      />

      {/* Review addon modal */}
      <ProcessAddon
        openModalReview={openModalReview}
        addon={addonInfo}
        handleAfterSubscribeAddon={handleAfterSubscribeAddon}
        handleReviewModal={() => setOpenModalReview(!openModalReview)}
        analytic={_.get(analytic, 'value', '365')}
        hadSubscribed={!isTrialPeriod}
      />
    </div>
  );
};

// Sub - components
// Get addon status
const getAddonStatus = (isTrialPeriod, cancelAt, storeStatus) => {
  if (storeStatus === 'expired') {
    return {
      color: 'new',
      status: 'expired',
      label: 'status_Expired',
      actionLabel: 'removeAddon'
    };
  }
  // Addon in trial period
  if (isTrialPeriod)
    return {
      color: 'attention',
      status: 'trial',
      label: 'status_Trial',
      actionLabel: 'removeAddon'
    };

  // Addon unsubscribed and will expire soon
  if (cancelAt)
    return {
      color: 'new',
      status: 'expireSoon',
      label: 'status_ExpiredSoon',
      actionLabel: 'resubscribeAddon'
    };

  // Addon subscribing
  return {
    color: 'info',
    status: 'paying',
    label: 'status_Paying',
    actionLabel: 'unsubscribe'
  };
};

export default withI18n()(AddonRow);
